import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import ProcedureValidationErrorInfoButton from 'procedures/design/buttons/ProcedureValidationErrorInfoButton';
import {getMethodNameOrPlaceholder} from 'procedures/design/procedureMethodNodeCommonConsts';
import {ProcedureValidationObjectType} from 'procedures/design/validation/ProcedureValidationTypes';
import {Method} from 'procedures/ProcedureDomainTypes';
import {ProcedurePageContext} from 'procedures/ProcedurePageContext';
import getProcedureUIString, {ProceduresStringKeys, StringCase} from 'procedures/ProceduresStringKeys';
import {BLUE} from 'ui-library/Colors';
import SelectDropdown from 'ui-library/dropdowns/SelectDropdown';
import BenchlingIcon from 'ui-library/icons/BenchlingIcon';
import Menu from 'ui-library/menus/Menu';
import Option from 'ui-library/menus/Option';

interface MethodSelectDropdownProps {
  selectedMethod: Method;
  methodNodes: Array<Method>;
  onChangeMethodSelection: (methodCid: string) => void;
  onAddMethod: () => void;
}

export default function MethodSelectDropdown(props: MethodSelectDropdownProps): JSX.Element {
  const {selectedMethod, methodNodes, onChangeMethodSelection, onAddMethod} = props;
  const {procedureType} = ProcedurePageContext.useContext();

  return (
    <SelectDropdown
      menu={
        <Menu height={Menu.HEIGHTS.SMALL} width={Menu.WIDTHS.SMALL} value={selectedMethod.cid}>
          {methodNodes.map((method) => (
            <Option key={method.cid} value={method.cid} onSelect={onChangeMethodSelection}>
              <div className={css(styles.methodDropdownOption)}>
                {getMethodNameOrPlaceholder(method.name, procedureType)}
                <ProcedureValidationErrorInfoButton
                  primaryObject={{
                    id: method.cid,
                    objectType: ProcedureValidationObjectType.METHOD,
                  }}
                />
              </div>
            </Option>
          ))}
          {methodNodes.length > 0 && (
            <Option key="Add method" value="Add method" onSelect={onAddMethod}>
              <div className={css(styles.addMethodOption)}>
                <BenchlingIcon icon="plus-large" />
                Add{' '}
                {getProcedureUIString(ProceduresStringKeys.METHOD, procedureType, {
                  stringCase: StringCase.LOWER,
                })}
              </div>
            </Option>
          )}
        </Menu>
      }
      alwaysDropDown={true}
      displayName={getMethodNameOrPlaceholder(selectedMethod.name, procedureType)}
      shouldEllipsize={true}
      className={css(styles.selectDropdown)}
    />
  );
}

const styles = StyleSheet.create({
  methodDropdownOption: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  selectDropdown: {
    width: '160px', // match the menu width
  },
  addMethodOption: {
    display: 'flex',
    fontWeight: 600,
    color: BLUE,
    gap: '6px',
    alignItems: 'center',
  },
});
